import { useRoute } from '@app/router';
import React, { useEffect } from 'react';
import { Form } from '@wikom/wikom-form';
import { post } from '@wikom/wikom-data/lib/actions';
import Symbol from '@wikom/react-symbol';
import { useAppDispatch, useAppSelector } from '@app/store';
import Layout from '../layout/Layout';
import PageHeader from '../components/PageHeader';
import useUser from '../hooks/useUser';
import EmailForm from '../forms/EmailForm';
import AlertComponent from '../components/Alert/AlertComponent';
import HelpModal from '../components/HelpModal';
import CmsContent from '../components/CmsContent';
import cmsId from '../constants/cmsId';
import useShowModal from '../hooks/useShowModal';
import { goToFailureState, goToInitialState, goToSuccessState } from '../actions/emailLwkActions';
var EmailLwk = function () {
    var ROUTE = useRoute();
    useEffect(function () {
        dispatch(goToInitialState());
    }, []);
    var showModal = useShowModal('helpmodal');
    var user = useUser();
    var uiState = useAppSelector(function (state) { return state.emailLwk; });
    var dispatch = useAppDispatch();
    var submitFn = function (values) { return function () { return post({ url: ROUTE.API.EMAIL_LWK_SEND(), data: values })
        .catch(function () { return dispatch(goToFailureState()); }); }; };
    var successFn = function (response) { var _a; return (((_a = response.body) === null || _a === void 0 ? void 0 : _a.success) ? goToSuccessState() : goToFailureState()); };
    return (React.createElement(Layout, null,
        React.createElement(PageHeader, { title: "Kontakt" },
            React.createElement("button", { type: "button", className: "btn", onClick: showModal },
                React.createElement(Symbol, { symbol: "question-circle" }),
                " Hilfe")),
        uiState.message
            && (React.createElement(AlertComponent, { name: "contactFormFeedback", isShown: true, level: uiState.message.level },
                React.createElement("div", { id: "contactFormFeedback" }, uiState.message.message))),
        !uiState.mailSend
            && (React.createElement(React.Fragment, null,
                React.createElement("p", null,
                    "Dieses Formular dient nur zur Kontaktaufnahme.",
                    React.createElement("br", null),
                    "Bitte verwenden Sie f\u00FCr Meldungen weiterhin die Ihnen bekannten Meldeformulare."),
                React.createElement("img", { src: "/images/status_yellow.png", alt: "Hinweis!" }),
                " Meldepflichtige Hinweise k\u00F6nnen hier nicht entgegen genommen werden!",
                React.createElement("br", null),
                React.createElement("br", null),
                React.createElement(Form, { name: "email_lwk", checkUrl: ROUTE.API.EMAIL_LWK_CHECK(), submitHandler: submitFn, successHandler: successFn },
                    React.createElement(EmailForm, { user: user })))),
        React.createElement(HelpModal, { modalName: "helpmodal" },
            React.createElement(CmsContent, { page: cmsId.EmailLwkForm }))));
};
export default EmailLwk;
